import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PlanningDetailService } from '../planning-detail.service';
import { Observable, Subscription } from 'rxjs';
import { Product } from '../../../order/resources/product';
import { ProductDiffItem, diffProducts } from '../../../order/resources/product-diff';
import { map } from 'rxjs/operators';
import { StationService } from '../../../order/services/station.service';

@Component({
  selector: 'planning-diff-view',
  templateUrl: './planning-diff-view.component.html',
  styleUrls: ['./planning-diff-view.component.less']
})
export class PlanningDiffViewComponent implements OnInit, OnDestroy {
  @Input() productData$: Observable<Product>;

  constructor(public detailService: PlanningDetailService, private stationService: StationService) { }

  public diffData$: Observable<ProductDiffItem[] | false>
  private dataSub: Subscription;
  ngOnInit(): void {
    this.diffData$ = this.productData$.pipe(
      map(newProduct => {
        const oldProduct = this.detailService.originalQuoteProductsFlat.find(p => p.partNumber === newProduct.partNumber && p.revision === newProduct.revision);
        if (!oldProduct) return false;
        const qty = this.detailService.getProductQuantity(newProduct);
        return diffProducts(oldProduct, newProduct, qty, (step) => {
          const station = this.stationService.stationList.find(st => st.stationId === step.stationId);
          return station ?? null;
        });
      })
    );
    this.dataSub = this.diffData$.subscribe(d => this.detailService.diffDataCached = d);
  }

  ngOnDestroy(): void {
    if (this.dataSub) this.dataSub.unsubscribe();
  }

  

}
